module.exports = __webpack_public_path__ + "static/brochure-dfa00b7951a70cb9f93efa89d29077c1.pdf";